import { useEffect, useState } from 'react';

import { navigate, routes } from '@redwoodjs/router';
import { MetaTags, useQuery } from '@redwoodjs/web';

import AccessDenied from 'src/components/AccessDenied/AccessDenied';
import Loader from 'src/components/Loader/Loader';
import { NPIDataGrid } from 'src/components/NPIDataGrid/NPIDataGrid';
import { ROLE_PERMISSIONS } from 'src/constants/role-permissions';
import { GET_CHECK_IN_CALLS_SUCCESS } from 'src/graphql/queries/getCheckInCalls.query';
import useHasPermission from 'src/hooks/useHasPermission';
import { PageContent } from 'src/layouts/MainLayout/PageContent';
import { onError } from 'src/utils/utils';

import CheckInCallsGridColDef from './CheckInCallsGridColDef';

const CheckInCallsPage = () => {
    const [tableData, setTableData] = useState<any>({
        rows: [],
    });

    const hasPermission = useHasPermission(ROLE_PERMISSIONS.customerSuccess);

    const handleView = ({
        serviceId,
        checkInCallId,
    }: {
        serviceId: string;
        checkInCallId: string;
    }) => {
        navigate(routes.checkInCallDashboard({ serviceId, checkInCallId }));
    };

    const { data, loading } = useQuery(GET_CHECK_IN_CALLS_SUCCESS, {
        fetchPolicy: 'network-only',
        onError,
    });

    useEffect(() => {
        const scheduledCalls = data?.getSuccessCheckInCalls;

        if (scheduledCalls) {
            setTableData({
                rows: scheduledCalls,
            });
        } else {
            setTableData({
                rows: [],
            });
        }
    }, [data]);

    if (loading || !data) return <Loader />;

    if (!hasPermission) {
        return <AccessDenied permission={ROLE_PERMISSIONS.customerSuccess} />;
    }

    return (
        <PageContent heading="Check-In Calls" subHeading="Managing all Service Calls to Merchants">
            <MetaTags title="Check-In Calls" description="Check-In Calls page" />
            <NPIDataGrid
                rows={tableData?.rows}
                columns={CheckInCallsGridColDef()}
                getRowId={(row) => {
                    return row.id;
                }}
                handleView={({ serviceId, id }) => {
                    handleView({ serviceId, checkInCallId: id });
                }}
                title="Check-in Calls Page"
                dataTestId="check-in-calls-page-table"
            />
        </PageContent>
    );
};

export default CheckInCallsPage;
